import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { DialogHeaderComponent } from '../dialog-header/dialog-header.component';
import { KtSelectModule } from '../kt-select/kt-select.module';

export interface CsvExportColumn { id: string | number; label: string; }

/** The page retains its original form, formatter, row loading and file-download action. */
@Component({
  selector: 'app-csv-export-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, DialogHeaderComponent, KtSelectModule],
  templateUrl: './csv-export-dialog.component.html',
  styleUrls: ['./csv-export-dialog.component.scss']
})
export class CsvExportDialogComponent {
  @Input() title = 'Export CSV';
  @Input() rowsLabel = 'rows';
  @Input() form: UntypedFormGroup;
  @Input() columns: CsvExportColumn[] = [];
  @Input() selectionOnly = false;
  @Input() selectionCount = 0;
  @Input() pageCount = 0;
  @Input() totalCount = 0;
  @Input() busy = false;
  @Input() fixedScope = '';
  @Input() error = '';
  @Output() dismissed = new EventEmitter<void>();
  @Output() exported = new EventEmitter<void>();

  get canExport(): boolean { return !!this.form?.valid && !this.busy && (!this.selectionOnly || this.selectionCount > 0); }
  export(): void { if (this.canExport) this.exported.emit(); }
}
